<div class="page-container">
	<div class="page-body-container">
		<div class="card">
			<strong class="mb-2 block text-xl">Ups...</strong>
			<p class="mb-2 mt-0 py-0!">Die angeforderte Seite konnte nicht gefunden werden.</p>
			<button class="btn-primary mt-4" (click)="toHome()">
				<span>Zurück zur Home-Seite</span>
				<i class="fa-solid fa-angle-right self-center text-md pl-2"></i>
			</button>
		</div>
	</div>
</div>
